import React from 'react'
import MaterialSymbol from '../material-symbol'

const ChevronLeft = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="chevron_left" {...props} />
))

ChevronLeft.displayName = 'ChevronLeft'

export default ChevronLeft
